import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import FeedSection from '@/pages/home/components/FeedSection';
import CollectionSection from '@/pages/home/components/CollectionSection';
import TagSection from '@/pages/home/components/TagSection';
import CommentSection from '@/pages/home/components/CommentSection';
import SubmitCta from '@/pages/home/components/SubmitCta';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeedSection />
        <CollectionSection />
        <TagSection />
        <CommentSection />
        <SubmitCta />
      </main>
      <Footer />
    </div>
  );
}